import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './Ratings.module.scss';

const STARS_COUNT = 5;

const getRandomId = () => Math.floor(Math.random() * 10000);

const Ratings = ({
  label = '', rating = 0, reviewLink = '', reviews = 0,
}) => {

  const jumpLinkElementRef = useRef(null);

  useEffect(() => {
    // Attach Drupal behaviors, so a jump link event listener can be attached.
    if (jumpLinkElementRef?.current) {
      window.Drupal.attachBehaviors();
    }
  }, [jumpLinkElementRef]);

  if (!rating || rating === 0) {
    return null;
  }

  const getClassesForStarValue = (starValue) => {
    const starBaseClass = styles.star;
    if (starValue < 0.1) {
      return classnames(starBaseClass, styles['star--00']);
    }
    if (starValue < 0.4) {
      return classnames(starBaseClass, styles['star--25']);
    }
    if (starValue < 0.6) {
      return classnames(starBaseClass, styles['star--50']);
    }

    if (starValue < 0.9) {
      return classnames(starBaseClass, styles['star--75']);
    }

    return classnames(starBaseClass);
  };

  const constructStars = () => {
    const ratingWithoutDecimals = Math.trunc(rating);
    const starValues = Array.from(Array(STARS_COUNT).keys()).map((_, index) => {
      if (index + 1 <= ratingWithoutDecimals) {
        return 1;
      }
      if (index + 1 > ratingWithoutDecimals && index + 1 <= Math.ceil(rating)) {
        return rating % 1;
      }
      return 0;
    });

    return starValues.map((starValue) => {
      const starId = `star-id-${getRandomId()}`;
      const classesForStarValue = getClassesForStarValue(starValue);

      return <span key={starId} className={classesForStarValue} />;
    });
  };
  return (
    <a href={reviewLink} className={styles['review-rating-wrapper']} ref={jumpLinkElementRef}>
      <div className={styles.review__rating}>
        <div className={styles['star-rating']} aria-label={label}>
          {constructStars()}
        </div>
        <div className={styles['product-rating']}>{rating}</div>
        {reviewLink.length > 0 && (
          <div className={styles['product-rating-count']}>
            (
            {reviews}
            )
          </div>
        )}
      </div>
    </a>
  );
};

Ratings.propTypes = {
  rating: PropTypes.number,
  reviews: PropTypes.number,
  reviewLink: PropTypes.string,
  label: PropTypes.string,
};

export default Ratings;
